import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../css/EmployeeForms.css";
import { BASE_URL } from "../config";

const EmployeeStatutoryDetails = () => {
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}/api/states`)
      .then((res) => res.json())
      .then((data) => setStates(data))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (selectedState) {
      fetch(`${BASE_URL}/api/employees?state_id=${selectedState}`)
        .then((res) => res.json())
        .then((data) => setEmployees(data))
        .catch((err) => console.error(err));
    }
  }, [selectedState]);

  const handleEmployeeSelect = (employee) => {
    setSelectedEmployee(employee);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedEmployee(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetch(`${BASE_URL}/api/update_statutory_details/${selectedEmployee.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(selectedEmployee)
    })
      .then(res => res.json())
      .then(() => {
        alert("Statutory details updated successfully!");
        // Refresh employee list
        fetch(`${BASE_URL}/api/employees?state_id=${selectedState}`)
          .then((res) => res.json())
          .then((data) => setEmployees(data));
      })
      .catch(err => console.error("Update failed:", err));
  };

  return (
    <div className="employee-main-container">
      <Header />
      <Navbar />

      <div className="employee-content-container">
        <div className="employee-heading-container">
          <h2 className="employee-title">Employee Statutory Details</h2>
        </div>

        <div className="employee-filter-container">
          <label htmlFor="stateSelect">State: </label>
          <select
            id="stateSelect"
            className="employee-state-dropdown"
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
          >
            <option value="">Select State</option>
            {states.map((state) => (
              <option key={state.id} value={state.id}>
                {state.name}
              </option>
            ))}
          </select>
        </div>

        <div className="employee-table-container">
          <table className="employee-table">
            <thead className="text-white">
              <tr>
                <th>S.No</th>
                <th>ID</th>
                <th>Employee</th>
                <th>Division</th>
                <th>DOB</th>
                <th>DOJ</th>
                <th>Designation</th>
                <th>Mobile</th>
                <th>State</th>
                <th>HQ</th>
              </tr>
            </thead>
            <tbody>
              {employees.map((emp, index) => (
                <tr 
                  key={emp.id}
                  onClick={() => handleEmployeeSelect(emp)}
                  className={selectedEmployee?.id === emp.id ? "selected" : ""}
                >
                  <td>{index + 1}</td>
                  <td>{emp.id}</td>
                  <td>{emp.first_name} {emp.last_name}</td>
                  <td>{emp.division}</td>
                  <td>{emp.dob}</td>
                  <td>{emp.doj}</td>
                  <td>{emp.designation}</td>
                  <td>{emp.mobile}</td>
                  <td>{emp.state_name}</td>
                  <td>{emp.headquarter_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {selectedEmployee && (
          <div className="employee-details-form">
            <h3>Statutory Details for {selectedEmployee.first_name} {selectedEmployee.last_name}</h3>
            
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Aadhar</label>
                  <input
                    type="text"
                    name="aadhar"
                    value={selectedEmployee.aadhar || ""}
                    onChange={handleInputChange}
                  />
                </div>
                
                <div className="form-group">
                  <label>Pan No</label>
                  <input
                    type="text"
                    name="panNo"
                    value={selectedEmployee.panNo || ""}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>PF No</label>
                  <input
                    type="text"
                    name="pfNo"
                    value={selectedEmployee.pfNo || ""}
                    onChange={handleInputChange}
                  />
                </div>
                
                <div className="form-group">
                  <label>UAN No</label>
                  <input
                    type="text"
                    name="uanNo"
                    value={selectedEmployee.uanNo || ""}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>ESI No</label>
                  <input
                    type="text"
                    name="esiNo"
                    value={selectedEmployee.esiNo || ""}
                    onChange={handleInputChange}
                  />
                </div>
              </div>

              <div className="form-actions">
                <button type="submit" className="submit-btn">Update</button>
                <button 
                  type="button" 
                  className="cancel-btn"
                  onClick={() => navigate(-1)}
                >
                  Back
                </button>
              </div>
            </form>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default EmployeeStatutoryDetails;